"use client";

import { useMemo } from "react";

import { getClassFunctions } from "@/lib/utils/class.utils";
import { ClassMethods } from "@/types/class.type";

import { HttpApiFactory } from "./http-api-factory.utils";

export function useClientHttpActions(): ClassMethods<HttpApiFactory> {
    // const { data: session } = useSession();
    // const { activeProfile } = useCookieData();

    // Use useMemo to create a new instance when accessToken or activeProfile changes
    const instance = useMemo(() => {
        const httpInstance = new HttpApiFactory();

        // If there's an active profile, and it's a vendor, add the header
        // if (activeProfile?.id && activeProfile?.type === INeoProfileType.VENDOR) {
        //     httpInstance.appendSharedHeader("Neo-Vendor-Id", activeProfile.id);
        // }

        return httpInstance;
    }, []);

    // Keep the access token updated in the memoized instance when the session changes
    // useEffect(() => {
    //     if ((session as any)?.accessToken) {
    //         instance.accessToken = (session as any).accessToken; // Dynamically update the token
    //     }
    // }, [instance, session]);

    // Return the memoized functions with the up-to-date instance
    return getClassFunctions<HttpApiFactory>(instance);
}
